// src/services/ownerAuthService.js
import axios from 'axios';
import store from '../store';

// ✅ 백엔드 기본 주소 설정
axios.defaults.baseURL = 'https://fastapi-backend-657266059621.asia-northeast1.run.app';
const API_BASE = '/api/owner';

export async function loginOwner(email, password) {
  try {
    const response = await axios.post(`${API_BASE}/login`, { email, password });
    const token = response.data.access_token;
    
    // Redux store 업데이트
    store.dispatch({ type: 'ownerAuth/loginSuccess', payload: token });
    
    // axios 기본 헤더 설정
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    
    return response.data;
  } catch (error) {
    store.dispatch({ type: 'ownerAuth/loginFailure', payload: error.response?.data?.detail || '로그인 실패' });
    throw error;
  }
}

export function logoutOwner() {
  // Redux store 업데이트
  store.dispatch({ type: 'ownerAuth/logout' });
  
  // axios 헤더 제거
  delete axios.defaults.headers.common['Authorization'];
}

export async function fetchOwnerClub() {
  try {
    const token = store.getState().ownerAuth.token;
    if (token) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    }

    const response = await axios.get(`${API_BASE}/club/me`);
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      store.dispatch({ type: 'ownerAuth/logout' });
    }
    throw error;
  }
}
